import React from 'react';
import PropTypes from 'prop-types';
import css from './SlotLabel.css';
import SlotLabelInfoRow from './SlotLabelInfoRow';
import Icon from '../../../SF/MaterialIcon';
import { getWord } from "utils/tenant";

export default class SlotLabel extends React.Component {

  get groupIcon() {
    return this.props.slot.slotForGroupSession
      ? <Icon aria-label={`This is a ${getWord('groupSession')}`} title={getWord('groupSession')} icon="group" />
      : null;
  }

  get infoRow() {
    return !this.props.slot.showServiceProviderInfo
      ? <SlotLabelInfoRow
        isService={this.props.slot.slotForService}
        courseContextName={this.props.slot.courseContextName}
      />
      : <SlotLabelInfoRow
        location={this.props.slot.slotLocationName}
        isService={this.props.slot.slotForService}
        ownerName={this.props.slot.ownerName}
        ownerTitle={this.props.slot.ownerTitle}
        courseContextName={this.props.slot.courseContextName} />;
  }

  get secondRow() {
    return this.props.slot.slotForService && this.props.slot.showServiceProviderInfo
      ? (
        <div className={css['row-container']}>
          <div style={{backgroundImage: `url(${this.props.slot.ownerPhotoURL})`}} />
          {this.infoRow}
        </div>
      ) : this.infoRow;
  }

  render() {
    return (
    	<div className={css['container']}>
    		<div>
    			<div className={css['slot-date']}>{this.props.slot.slotTimeRange} {this.groupIcon}</div>
    			<div className={css['slot-duration']}>{this.props.slot.slotDuration}m</div>
    		</div>
    		{this.secondRow}
    	</div>
    );
  }
}

SlotLabel.propTypes = {
  slot: PropTypes.shape({
    courseContextName: PropTypes.string,
    ownerName: PropTypes.string.isRequired,
    ownerPhotoURL: PropTypes.string,
    ownerTitle: PropTypes.string.isRequired,
    selectedCourseName: PropTypes.string,
    showServiceProviderInfo: PropTypes.bool.isRequired,
    slotDuration: PropTypes.number.isRequired,
    slotForGroupSession: PropTypes.bool.isRequired,
    slotForService: PropTypes.bool.isRequired,
    slotLocationName: PropTypes.string,
    slotTimeRange: PropTypes.string.isRequired
  }).isRequired
};
